<template>
  <div id="app">
    <div v-if="hasError === null">
      <div v-if="isLoading === false">
        <music-icon></music-icon>
        <background />
        <show-out />
      </div>
    </div>

    <div v-if="isLoading === true">
      <loading />
    </div>

    <div v-if="hasError !== null">
      <failed></failed>
    </div>

    <div v-if="isComputer">
      <Tip></Tip>
    </div>
  </div>
</template>

<script>
import store from '@/store/store'
import Background from '@/components/utils/background'
import Loading from '@/components/statePages/loading'
import Failed from '@/components/statePages/failed'
import ShowOut from '@/components/showOut'
import MusicIcon from '@/components/utils/musicIcon'
import Tip from '@/components/statePages/Tip'

export default {
  name: 'Home',
  components: {
    Tip,
    MusicIcon,
    ShowOut,
    Failed,
    Loading,
    Background,
  },
  watch: {},
  data() {
    return {
      isComputer: false,
    }
  },
  computed: {
    isLoading: function () {
      return store.state.isLoading
    },
    hasError: function () {
      return store.state.HasError
    },
    index: function () {
      return store.state.index
    },
  },
  mounted() {
    // 判断是否是电脑用户
    let userAgentInfo = window.navigator.userAgent
    let Agents = [
      'Android',
      'iPhone',
      'SymbianOS',
      'Windows Phone',
      'iPad',
      'iPod',
    ]
    let flag = true
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false
        break
      }
    }
    this.isComputer = flag
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--light-color);
  width: 100vw;
  height: 100vh;
  background-color: #3498db;
  vertical-align: baseline;
}
html,
body {
  height: 100%;
}
</style>
